var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"max-width":"600"}},[_c('v-main',{staticClass:"main"},[_c('TopBar',{attrs:{"menu":_vm.menu}}),_c('router-view',{on:{"set-menu":_vm.setMenu}})],1),_c('Menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }